import { render, staticRenderFns } from "./FootPc.vue?vue&type=template&id=6ed94985&scoped=true&"
import script from "./FootPc.vue?vue&type=script&lang=js&"
export * from "./FootPc.vue?vue&type=script&lang=js&"
import style0 from "./FootPc.vue?vue&type=style&index=0&id=6ed94985&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed94985",
  null
  
)

export default component.exports